<div class="years-container">
    <h3 class="years-title text-center">Select tax year</h3>

    <div class="years-list">
        <ul>
            <li>
                <div class="option-container d-flex align-items-center bb">
                    <div class="icon-container">
                        <i class="icon icon-CalendarRange"></i>
                    </div>
                    <label
                        class="tax-option d-flex justify-content-between align-items-center w-100">
                        2026
                        <input
                            type="radio"
                            name="taxYear"
                            [value]="2026"
                            (change)="selectedYear = 2026" />
                    </label>
                </div>
            </li>
            <li>
                <div
                    class="option-container d-flex align-items-center"
                    [class.pb_10]="is2025Available">
                    <div class="icon-container">
                        <i class="icon icon-CalendarRange"
                            [class.icon-eye]="is2025Available"></i>
                    </div>
                    <label
                        class="tax-option d-flex justify-content-between w-100"
                        [class.disabled]="!is2025Available">
                        <div>
                            2025
                            <p
                                *ngIf="is2025Available && selectedYear !== 2025"
                                class="tax-option--info">
                                Tax Year 2025 is available in read-only mode.
                            </p>
                        </div>
                        <input
                            type="radio"
                            name="taxYear"
                            [value]="2025"
                            [disabled]="!is2025Available"
                            (change)="selectedYear = 2025" />
                    </label>
                </div>
            </li>
        </ul>
    </div>
    <div
        *ngIf="selectedYear === 2025"
        class="info-note">
        <div class="info-note--header d-flex align-items-center">
            <img
                src="../../../assets/icons/sprintax-icon.svg"
                alt="" />
            <p class="tax-option--info mt_16">Tax Year 2025 is available in read-only mode.</p>
        </div>
        <p>
            You can review any information previously entered, but you can’t edit or add new
            details. To start 2026, navigate back to the dashboard.
        </p>
    </div>
    <div class="d-flex mt_24">
        <button
            type="button"
            class="ms-auto btn btn--blue d-flex align-items-center"
            [disabled]="!selectedYear"
            (click)="onContinue()">
            Continue
            <i class="icon icon-stroke ml_8"></i>
        </button>
    </div>
</div>
